import { HttpHeaders } from '@angular/common/http';

export class Header {
  //Local(Solo uso para backend)
 // url = "http://localhost:5050/v1/rest/api/"


  //produccion
  url ="http://84.247.165.214:5050/v1/rest/api/"



  parametro = new HttpHeaders({ 'content-type': 'application/json' });

  parametroSinContentType(): HttpHeaders {
    return new HttpHeaders();
  }
}
